export default function useSearch() {
  const onSearch = (value: string, data: any) => {
    if (!!data && !!value) {
      const filteredData = data.filter((item: any) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      return filteredData;
    } else {
      return data;
    }
  };
  return { onSearch };
}
